import { useHttpClient } from '../hooks/useHttpClient';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import { isEmptyArray } from 'formik';
import AutoFocusDropdown from './AutoFocusDropdown';
import { setEmisor, setUserAccess } from '../pages/Login/reducer';
import { Skeleton } from 'primereact/skeleton';
import { useMountEffect, useUpdateEffect } from 'primereact/hooks';
import { isEmpty } from 'lodash';

const SeleccionarEmisorSesion = (props) => {
    const httpClient = useHttpClient();
    const emisorSeleccionado = useSelector((state) => state.session.emisorSeleccionado);
    const empresa = useSelector((state) => state.session.empresa);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const userAccess = useSelector((state) => state.session.userAccess);

    useMountEffect(() => {
        if (isEmptyArray(userAccess)) {
            setIsLoading(true);
            httpClient
                .get('admin/emisor/all')
                .then((response) => {
                    const tmpIssuers = [];
                    for (let i = 0; i < response.data.length; i++) {
                        const issuer = response.data[i];

                        if (empresa === issuer.ruc) {
                            dispatch(
                                setEmisor({
                                    code: issuer.ruc,
                                    name: issuer.razon_social
                                })
                            );
                        }

                        tmpIssuers.push({
                            code: issuer.ruc,
                            name: issuer.razon_social
                        });
                    }
                    dispatch(setUserAccess(tmpIssuers));
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAccess, emisorSeleccionado]);

    useUpdateEffect(() => {
        if (!isEmpty(empresa) && !isEmpty(userAccess)) {
            for (let i = 0; i < userAccess.length; i++) {
                const issuer = userAccess[i];

                if (empresa === issuer.code) {
                    dispatch(setEmisor(issuer));
                }
            }
        }
    }, [userAccess, empresa]);

    const getSelect = () => {
        if (isLoading) {
            return <Skeleton disabled={true} width={'30rem'} height={'2.5rem'} className="mb-2"></Skeleton>;
        }

        return (
            <AutoFocusDropdown
                id={props.id}
                filter
                disabled={props.disabled}
                value={emisorSeleccionado}
                checkmark={true}
                onChange={(e) => dispatch(setEmisor(e.value))}
                options={userAccess}
                optionLabel="name"
                placeHolder="Seleccione un emisor"
                className={props.className}
            />
        );
    };

    return getSelect();
};

export default SeleccionarEmisorSesion;
